import React from "react";
import { fmtAmount } from "./bookingPricing";
import DepositInfoBox from "./DepositInfoBox";

interface Confirmation {
  reservationId: string;
  nights: number;
  amount: number;
  apartmentName: string;
}

interface Props {
  confirmation: Confirmation;
  currency?: string;
  onFinish: () => void;
  finishLabel: string;
  t: (key: any) => any;
}

const ConfirmationScreen: React.FC<Props> = ({ confirmation, currency, onFinish, finishLabel, t }) => (
  <div className="pab-confirm">
    <div className="pab-confirm__icon">
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 6L9 17l-5-5" />
      </svg>
    </div>
    <h1 className="pab-confirm__title">{t("reservationSent")}</h1>
    <div className="pab-confirm__msg">{t("thankYouFull")}</div>

    <div className="pab-confirm__card">
      <div className="pab-confirm__row">
        <span>{t("apartment")}</span>
        <span className="pab-confirm__val">{confirmation.apartmentName}</span>
      </div>
      <div className="pab-confirm__row">
        <span>{t("nights")}</span>
        <span className="pab-confirm__val">{confirmation.nights}</span>
      </div>
      <div className="pab-confirm__row pab-confirm__row--total">
        <span>{t("total")}</span>
        <span className="pab-confirm__val">{fmtAmount(confirmation.amount, currency)}</span>
      </div>
      {confirmation.reservationId && (
        <div className="pab-confirm__id">
          Broj rezervacije: <strong>#{String(confirmation.reservationId).slice(-6).toUpperCase()}</strong>
        </div>
      )}
    </div>

    <DepositInfoBox amount={confirmation.amount} currency={currency} t={t} />

    <button type="button" className="pab-cta-btn pab-cta-btn--outline pab-confirm__btn" onClick={onFinish}>
      {finishLabel}
    </button>
  </div>
);

export default ConfirmationScreen;
